import { API } from './index';

export function createTicket(formData: FormData): Promise<any> {
    return API.post('/support/create-ticket', formData);
}

export function getTickets(): Promise<any> {
    return API.get(`/support/get-tickets`);
}

export function getTicket(ticketId: string): Promise<any> {
    return API.get(`/support/get-ticket?id=${ticketId}`);
}

export function sendMessage(formData: FormData): Promise<any> {
    return API.post('/support/send-message', formData);
}

export function mergeUserId(): Promise<any> {
    return API.post('/support/merge-user-id');
}

export function getSupportUnreadMessageCount(): Promise<any> {
    return API.get('/support/get-support-unread-message-count');
}